import React from 'react';
import { Wrapper, Header } from '../forms/Form';
import { popupComponents$ } from '../../supplementary_components/store';
import styles from './descriptionPopup.module.scss';

export const ENTITY_DESCRIPTION_POPUP_KIND = 'entityDescription';

export function openDescriptionPopup({
    titleLabel = '',
    description = '',
    titlePrefix = 'Description',
    popupKind = ENTITY_DESCRIPTION_POPUP_KIND,
    emptyMessage = 'No description',
    customMaxWidth = '42rem',
}) {
    const withoutExisting = popupComponents$.getValue().filter(
        (popup) => popup.popupData?.popupKind !== popupKind,
    );
    popupComponents$.next([
        ...withoutExisting,
        {
            content: DescriptionPopup,
            popupData: {
                popupKind,
                titleLabel,
                titlePrefix,
                description,
                emptyMessage,
            },
            EZCloseAllowed: true,
            customMaxWidth,
            customWidth: '100%',
        },
    ]);
}

export const DescriptionPopup = ({ popupData }) => {
    const titleLabel = popupData?.titleLabel ?? '';
    const titlePrefix = popupData?.titlePrefix ?? 'Description';
    const raw = popupData?.description;
    const text =
        raw != null && String(raw).trim() !== ''
            ? String(raw).trim()
            : popupData?.emptyMessage ?? 'No description';
    const isEmpty = raw == null || String(raw).trim() === '';

    return (
        <div className={styles.descriptionRoot} onClick={(e) => e.stopPropagation()}>
            <Wrapper style={{ width: '100%', maxWidth: '100%' }}>
                <Header>
                    <span>
                        {titlePrefix}
                        {titleLabel ? ` ${titleLabel}` : ''}
                    </span>
                </Header>
                <div className={styles.descriptionContent}>
                    <div
                        className={
                            isEmpty ? `${styles.descriptionBody} ${styles.descriptionEmpty}` : styles.descriptionBody
                        }
                    >
                        {text}
                    </div>
                </div>
            </Wrapper>
        </div>
    );
};

/**
 * Truncated list cell; opens {@link openDescriptionPopup} when description has text.
 */
export function ListDescriptionCell({
    description,
    titleLabel = '',
    titlePrefix = 'Description',
    popupKind = ENTITY_DESCRIPTION_POPUP_KIND,
    placeholder = '-',
}) {
    const text = description != null ? String(description).trim() : '';
    if (!text) {
        return <span className={styles.listDescriptionPlaceholder}>{placeholder}</span>;
    }
    return (
        <div className={styles.listDescriptionCell}>
            <button
                type="button"
                className={styles.listDescriptionTrigger}
                title={text}
                onClick={(e) => {
                    e.stopPropagation();
                    openDescriptionPopup({
                        titleLabel,
                        description: text,
                        titlePrefix,
                        popupKind,
                    });
                }}
            >
                {text}
            </button>
        </div>
    );
}
